export default {
  name: 'directions',
  props: {}
}
